import React, { useEffect, useState } from "react";
import { timeout } from "../../../../Utils";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip/index.tsx";
import ThumbsUp from "../../shared/ThumbsUp";
import ThumbsDown from "../../shared/ThumbsDown";

import {
  StyledMaybe,
  StyledMaybeRight,
  StyledMaybeLeft,
  StyledMaybeMiddle,
  StyledMaybeContainer,
} from "./styles";

const Maybe = ({
  content,
  index,
  rotation,
  items,
  setAnimating,
  animating,
  handleSeenTip,
  hasThumbsedUp,
  setHasThumbsedUp,
  setDecoyContent,
  setIsThumbsed,
  setDecoyLeft,
  setDecoyTop,
  listScrolled, //refers to the maybe list
}) => {
  const totalCardHeight = 122;
  const cardOffset = 43;

  const [born, setBorn] = useState(false);
  const [kept, setKept] = useState("");

  useEffect(() => {
    setTimeout(() => {
      if (!born) setBorn(true);
    }, 200);

    return function cleanup() {
      if (animating) setAnimating(false);
    };
  }, []);

  const handleThumbsUp = async () => {
    if (!animating) {
      if (!hasThumbsedUp) setHasThumbsedUp(true);
      handleSeenTip(3);
      setAnimating(true);
      setDecoyContent(content);
      setIsThumbsed("up");
      setDecoyLeft("-501");
      setDecoyTop(index * totalCardHeight - totalCardHeight + cardOffset - listScrolled);
      setKept("invisible");
      await timeout(600);
      setKept("invisible small");
    }
  };

  const handleThumbsDown = async () => {
    if (!animating) {
      handleSeenTip(3);
      setAnimating(true);
      setDecoyContent(content);
      setIsThumbsed("down");
      setDecoyLeft("-498");
      setDecoyTop(index * totalCardHeight - totalCardHeight + cardOffset - listScrolled);
      setKept("invisible");
      await timeout(400);
      setKept("invisible small");
    }
  };

  const keptClassName = kept;

  return (
    <StyledMaybeContainer
      key={content}
      className={keptClassName}
      rotation={rotation}
      index={index}
      items={items.length}
      born={born}
      contentLength={content.length}
    >
      <StyledMaybe>
        <StyledMaybeRight onClick={handleThumbsUp}>
          <ThumbsUp color={"var(--icon-button-fill"} opacity={"var(--icon-button-opacity"} />
        </StyledMaybeRight>
        <StyledMaybeLeft onClick={handleThumbsDown} opacity={1}>
          <ThumbsDown color={"var(--icon-button-fill"} opacity={"var(--icon-button-opacity"} />
        </StyledMaybeLeft>
        <StyledMaybeMiddle length={content.length}>
          <SudoTooltip
            text={content}
            disabled={content.length <= 150}
            position="top"
          >
            <span>{content}</span>
          </SudoTooltip>
        </StyledMaybeMiddle>
      </StyledMaybe>
    </StyledMaybeContainer>
  );
};

export default Maybe;
